module.exports = __webpack_public_path__ + "img/active-ruzhi.f5311135.png";